// extracted by mini-css-extract-plugin
export default {"left_box":"index_left_box_GCpat","dbox":"index_dbox_LsZbZ","adBox":"index_adBox_3DSaL"};